/**
 * El enlace de Discord de la sección "acerca de".
 *
 * Es lo único de esa sección que no esta escrito en el HTML, y por el mismo
 * motivo que en el cliente (`client/src/views/AboutView.vue`): una invitación
 * de Discord caduca, y cambiarla no debería obligar a tocar el código. Viaja en
 * `VITE_DISCORD_URL`.
 *
 * Sin valor configurado NO se enseña enlace: se queda el texto "invitación
 * pendiente" que ya esta en la página. Un enlace roto es peor que ninguno.
 *
 * Vive aparte de `status.ts` a propósito: aquel lee un fichero de red y este
 * solo mira una constante horneada en el bundle. Juntarlos haría que un fallo
 * de red se llevara por delante un enlace que no depende de la red.
 */

const url = String(import.meta.env.VITE_DISCORD_URL ?? '').trim()

// Se comprueba que sea una URL http(s) de verdad y no cualquier cadena: el valor
// viene de una variable de entorno que rellena a mano quien despliega, y un
// `href` con un esquema inesperado es una via de inyección, no una errata.
function esEnlaceValido(candidato: string): boolean {
  if (!candidato) return false
  try {
    const { protocol } = new URL(candidato)
    return protocol === 'https:' || protocol === 'http:'
  } catch {
    return false
  }
}

if (esEnlaceValido(url)) {
  const enlace = document.querySelector<HTMLAnchorElement>('[data-discord]')
  const pendiente = document.querySelector<HTMLElement>('[data-discord-pendiente]')

  if (enlace && pendiente) {
    enlace.href = url
    enlace.hidden = false
    pendiente.hidden = true
  }
}
